import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Location, UserProfile } from '../../../../../@posturinn/client-react';
import { updateUserProfile } from '../../../../../actions/userProfileActions';
import IUserProfileReducer from '../../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../../reducers';
import * as StyledModals from '../../myShipmentsModals.styles';
import * as StyledDeliveryOptionsList from './deliveryOptionsList.styles';

interface Props {
	locations: Location[];
	selectedLocation: string;
	setSelectedLocation: any;
	search: any;
}

const DeliveryOptionList: FC<Props> = ({ locations, selectedLocation, setSelectedLocation, search }) => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { modalSubmitPending, userProfile } = userProfileReducer;

	const updateDeliveryOption = location => {
		const newUserProfile: UserProfile = userProfile.clone();
		newUserProfile.preferredDeliveryMethodLocationId = location.id;
		newUserProfile.preferredDeliveryMethod = location.locationType;
		dispatch(updateUserProfile(newUserProfile));
	};

	return (
		<StyledDeliveryOptionsList.Wrapper>
			{locations?.map(
				location =>
					search(location) && (
						<div key={location.id} id={location.id}>
							<StyledModals.CardWrapper highlight={location.id === selectedLocation}>
								<StyledModals.CardLink
									highlight={location.id === selectedLocation}
									onClick={() => {
										setSelectedLocation(location.id, location.latitude, location.longitude, false);
									}}>
									<StyledModals.CardHeading>
										<div>{location.name}</div>
										<div>{location.address.postalCode}</div>
									</StyledModals.CardHeading>
									<StyledModals.CardSubHeading>
										{location.address.street1}
									</StyledModals.CardSubHeading>
									<div>{location.statusMessage}</div>
								</StyledModals.CardLink>
								{location.id === selectedLocation && (
									<StyledModals.CardFooter
										onClick={() => updateDeliveryOption(location)}
										disabled={modalSubmitPending}>
										{t('page-settings.chooseDeliveryOption')}
									</StyledModals.CardFooter>
								)}
							</StyledModals.CardWrapper>
						</div>
					)
			)}
		</StyledDeliveryOptionsList.Wrapper>
	);
};

export default DeliveryOptionList;
